export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen flex-col bg-bone">
      <header className="border-b border-ink/15">
        <div className="mx-auto flex max-w-6xl items-center px-6 py-5 md:px-10">
          <a href="/" data-testid="cancel-brand-link" className="flex items-center gap-3">
            <img
              src="/assets/wmwe-logo-dark.png"
              alt="WMWE logo"
              className="h-9 w-9 rounded-full border border-ink/15 bg-cream object-contain p-[3px]"
            />
            <span className="font-sans text-[11px] tracking-[0.35em] text-ink">
              RECON 2026 <span className="text-ink/40">// CHECKOUT PAUSED</span>
            </span>
          </a>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-6 py-20">
        <div className="w-full max-w-xl border border-ink/25 bg-manila p-10 text-center md:p-14">
          <h1 className="font-serif text-4xl font-medium tracking-tight text-ink md:text-5xl">
            Checkout <span className="italic text-wine">paused.</span>
          </h1>
          <p className="mt-6 text-sm leading-relaxed text-smoke">
            No charge was made. Your seat is still waiting — the room wouldn't be the same without
            your intelligence in it.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              href="/checkout"
              data-testid="cancel-retry-link"
              className="border border-wine bg-wine px-8 py-3 font-sans text-[10px] tracking-[0.35em] text-bone transition-colors duration-300 hover:bg-navy"
            >
              RETURN TO TICKETS
            </a>
            <a
              href="/"
              data-testid="cancel-home-link"
              className="border border-ink/30 px-8 py-3 font-sans text-[10px] tracking-[0.35em] text-ink transition-colors duration-300 hover:border-wine hover:text-wine"
            >
              ← THE BRIEFING
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
